<div class="iss-side-nav-header">
  <img
    [src]="'wo-common/assets/swc-logo_180x166.webp' | woFileHash"
    alt="ISS"
    class="iss-side-nav-header-logo"
  />
  <div class="iss-side-nav-header-content">
    <div class="is-hidden-mobile">
      <ng-content/>
    </div>
    <iss-icon
      class="iss-side-nav-header-icon"
      name="return"
      (click)="toggle.emit()"
    />
  </div>
</div>
